import React, { Suspense } from 'react';
import { Route } from 'react-router-dom'
import PreLoader from '../components/elements/PreLoader';
import AuthHeader from '../components/header/AuthHeader';

/* Popup Layout */
const AuthLayout = ({ children, isPage, ...rest }) => {
  const bodyBg = rest.pageBgData && rest.pageBgData
    .filter((data) => data.backgroundType === BackgroundTypeEnum.Body)
    .filter((element) => {
      const elementPages = element.pages.filter((el) => el.prefix + el.alias === rest.alias || el.prefix + el.alias + '-lobby' === rest.alias);
      return element.forAllPages ? true : elementPages && elementPages.length ? true : false;
    });

  return (
    <div className={`wrappers ${isPage ? 'multi-view__hidden-menu popup-to-page__wrapper' : ''}`}>
      {/* <Suspense fallback={<></>}>
        {!Utils.isTablet() && <SideBarMenu />}
      </Suspense> */}
      <AuthHeader />
      <main
        className={`main-block ${bodyBg && bodyBg.length ? StylesHelper.getBgSize(bodyBg) : ''}  ${bodyBg && bodyBg.length && bodyBg[0].backgroundPosition === BackgroundPositionEnum.Fixed ? 'main-img_fixed' : ''} `}
      >
        {getContent({ children, ...rest })}
      </main>
    </div>
  )
}

/* Popup Layout */
const getContent = ({ children, ...rest }) => {
  return rest.isSettingsLoading ? <PreLoader spinning={rest.isSettingsLoading}>
    <div style={{ height: '100%', width: '100%' }}></div>
  </PreLoader> : children
}

/*
  Private route wrapper
 */

export const AuthRoute = ({ component: Component, isSettingsLoading, isPage, ...rest }) => {
  return (
    <Route {...rest} render={matchProps => {
      return (
        rest.language ? <AuthLayout key={rest.language} isSettingsLoading={isSettingsLoading} isPage={isPage}> 
          <Suspense fallback={<PreLoader spinning={rest.isSettingsLoading}>
            <div style={{ height: '100%', width: '100%' }}></div>
          </PreLoader>}>
            <Component {...matchProps} />
          </Suspense>
        </AuthLayout> : null
      )
    }} />
  )
};

